import React, { useEffect, useState } from 'react';
import qs from 'qs';
import { Box } from '@mui/material';

import API from '@api/index';
import { QRCodeBoard } from '@components/_index';

import '@template/components/InfosPart/QRImageBoard/QRImageBoard.scss';

export default function QRImageBoard({ fieldValue }) {
    const location = window.location;
    const queryUrl = qs.parse(location.search, { ignoreQueryPrefix: true });
    const { token, orderNo } = queryUrl;
    const [imageData, setImageData] = useState(null);

    useEffect(() => {
        API.order.orderAccountImage(token, orderNo).then(res => {
            if(!!res.data) {
                setImageData(URL.createObjectURL(res.data));
            }
        });
    }, []);

    return (
        imageData ? 
            <Box className="qrImageBoardWrapper">
                <img className="qrImage" src={imageData} key="qrImage" alt="QR CODE" />
            </Box>
            :
            <QRCodeBoard fieldValue={fieldValue} />
    );
}